import { ShieldCheck } from "lucide-react";
import { Accordion, AccordionContent, AccordionItem, AccordionTrigger } from "@/components/ui/accordion";

const Row = ({ label, value, testId }) => (
  <div className="flex items-baseline justify-between gap-4 py-2.5">
    <span className="text-sm text-zinc-400">{label}</span>
    <span className="text-right text-sm text-white" data-testid={testId}>{value}</span>
  </div>
);

export function VoiceRates({ config, balance }) {
  if (!config?.available) return null;
  const { rates, billing } = config;
  return (
    <section className="rounded-2xl border border-white/[0.08] bg-ink-850 p-5 sm:p-6" data-testid="voice-rates">
      <h2 className="text-base font-medium text-white md:text-lg">Before you start</h2>
      <p className="mt-1 text-sm text-zinc-500">Voice is paid from your prepaid credits. These are the current rates.</p>
      <div className="mt-4 divide-y divide-white/[0.06]">
        <Row label="Listening" value={`${rates.listening_per_minute} credits / minute`} testId="voice-rate-listening" />
        <Row label="Speaking" value={`${rates.speaking_per_1k_chars} credits / 1,000 characters`} testId="voice-rate-speaking" />
        <Row label="Answers" value="Normal chat rate" testId="voice-rate-answers" />
        <Row label="Your balance" value={balance == null ? <span className="inline-block h-4 w-20 animate-pulse rounded bg-white/[0.08] align-middle" /> : `${balance.toLocaleString()} credits`} testId="voice-rate-balance" />
      </div>
      <Accordion type="single" collapsible className="mt-2">
        <AccordionItem value="billing" className="border-white/[0.06]">
          <AccordionTrigger className="text-sm text-zinc-300 hover:no-underline" data-testid="voice-billing-toggle">How voice billing works</AccordionTrigger>
          <AccordionContent>
            <ul className="space-y-2 text-[13px] leading-relaxed text-zinc-400" data-testid="voice-billing-details">
              {billing.map((line) => <li key={line} className="flex gap-2"><span className="mt-2 h-1 w-1 shrink-0 rounded-full bg-zinc-500" />{line}</li>)}
            </ul>
          </AccordionContent>
        </AccordionItem>
      </Accordion>
      <p className="mt-4 flex items-start gap-2 text-xs text-zinc-500">
        <ShieldCheck className="mt-px h-4 w-4 shrink-0 text-emerald-400/80" strokeWidth={1.6} />
        The microphone only turns on when you tap, and turns off when you tap again. Recordings are never stored.
      </p>
    </section>
  );
}
